// ContactComponent.jsx — FULL (unique classes + same design language)
import React, { useState } from "react";
import "../../styles/about/Contact.css";
import {
  FaPhone,
  FaMapMarkerAlt,
  FaClock,
  FaInstagram,
  FaFacebook,
  FaEnvelope,
  FaViber,
} from "react-icons/fa";
import api from "../../api/http";

const ContactComponent = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [messageSent, setMessageSent] = useState(false);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const validate = () => {
    if (!formData.name.trim()) return "Te rog completează numele.";
    if (!formData.email.trim()) return "Te rog completează email-ul.";
    if (!formData.phone.trim()) return "Te rog completează telefonul.";
    if (!formData.message.trim()) return "Te rog completează mesajul.";
    if (!/^\S+@\S+\.\S+$/.test(formData.email.trim())) return "Email invalid.";
    return "";
  };

  const parseError = (err) => {
    const data = err?.response?.data;
    if (!data) return "Eroare la trimiterea mesajului.";

    if (typeof data === "string") return data;
    if (typeof data.detail === "string") return data.detail;

    if (typeof data === "object") {
      const msg = Object.entries(data)
        .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : String(v)}`)
        .join("\n");
      return msg || "Eroare la trimiterea mesajului.";
    }

    return "Eroare la trimiterea mesajului.";
  };

  const sendMessage = async () => {
    setError("");
    setMessageSent(false);

    const v = validate();
    if (v) {
      setError(v);
      return;
    }

    if (sending) return;

    setSending(true);
    try {
      // dacă la tine endpoint-ul e cu "/" la final -> schimbă în "/about/send-email/"
      const res = await api.post("/about/send-email", formData);

      if (res?.data?.success === true || res.status === 200) {
        setMessageSent(true);
        setFormData({ name: "", email: "", phone: "", message: "" });
        setTimeout(() => setMessageSent(false), 5000);
      } else {
        setError("Eroare la trimiterea mesajului.");
      }
    } catch (err) {
      setError(parseError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="srContact_page">
      <div className="srContact_wrap">
        <div className="srContact_header">
          <h2 className="srContact_title">Contacte</h2>
          <p className="srContact_subtitle">Scrie-ne și revenim cât mai rapid</p>
        </div>

        <div className="srContact_grid">
          {/* RIGHT: OFFICE (Moved to top for mobile) */}
          <div className="srContact_card srContact_office">
            <div className="srContact_officeHead">
              <h3 className="srContact_cardTitle">Oficiul Central</h3>
              <span className="srContact_badge">24/7</span>
            </div>

            <div className="srContact_links">
              <a className="srContact_link" href="tel:+37378733723" rel="noopener noreferrer">
                <FaPhone /> <span>+373 787 33 723</span>
              </a>

              <a className="srContact_link" href="tel:+37378733723" rel="noopener noreferrer">
                <FaViber /> <span>Viber: +373 787 33 723</span>
              </a>

              <a
                className="srContact_link"
                href="https://www.google.com/maps/search/?api=1&query=Balti+str.+Kiev+48A"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaMapMarkerAlt /> <span>Bălți, str. Kiev 48A</span>
              </a>

              <a
                className="srContact_link"
                href="https://www.instagram.com/supreme__rentals/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram /> <span>Supreme Rentals</span>
              </a>

              <a
                className="srContact_link"
                href="https://www.facebook.com/ChirieAutoBALTI"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook /> <span>Supreme Rentals</span>
              </a>

              <a
                className="srContact_link"
                href="mailto:supremerentals.srl@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaEnvelope /> <span>supremerentals.srl@gmail.com</span>
              </a>

              <div className="srContact_meta">
                <FaClock /> <span>Orar de lucru: 24/7</span>
              </div>
            </div>
          </div>

          {/* LEFT: FORM */}
          <div className="srContact_card">
            <h3 className="srContact_cardTitle">Trimite un mesaj</h3>

            <div className="srContact_form">
              <label className="srContact_field">
                <span>Nume/Prenume</span>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Nume/Prenume"
                />
              </label>

              <label className="srContact_field">
                <span>Email</span>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                />
              </label>

              <label className="srContact_field">
                <span>Telefon</span>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Telefon"
                  inputMode="tel"
                />
              </label>

              <label className="srContact_field srContact_full">
                <span>Mesaj</span>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Mesaj"
                  rows={5}
                />
              </label>

              {error && <div className="srContact_msg srContact_msgErr">{error}</div>}
              {messageSent && (
                <div className="srContact_msg srContact_msgOk">
                  Mesaj trimis cu succes! În scurt timp vă vom telefona.
                </div>
              )}

              <button
                className="srContact_btn srContact_btnPrimary srContact_full"
                onClick={sendMessage}
                disabled={sending}
                type="button"
              >
                {sending ? "Se trimite..." : "Trimite"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactComponent;